document.addEventListener("DOMContentLoaded", () => {
  const animationTriggerElements = document.querySelectorAll('.line-wrapper');

  if (animationTriggerElements.length === 0) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('line-wrapper--visible');
        observer.unobserve(entry.target); // アニメーション後に監視を解除
      }
    });
  }, {
    rootMargin: '0px 0px -50px 0px', // ビューポートの下から50pxでトリガー
  });

  animationTriggerElements.forEach((element) => observer.observe(element));
});
